import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_2 = ["value", "checked", "disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer- peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 border border-gray-500 after:bg-gray-500 peer-checked:after:bg-white" }, null, -1)




export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleCheckbox',
  props: {
  value: {
    type: Boolean,
    required: true,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["toggle"],
  setup(__props, { emit: emits }) {

const props = __props;





function emit() {
  return emits("toggle", props.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      value: __props.value,
      checked: __props.value,
      class: "sr-only peer",
      onChange: emit,
      disabled: __props.readonly
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}
}

})